import React, { Component, createRef  } from 'react';
import './css/ListChatSupportUser.css';
import { toast } from 'react-toastify';
import axios from 'axios';
import $ from 'jquery';
import Firebase from '../../components/Firebase.js';
import lodash from 'lodash'
import { Base64 } from 'js-base64';
import MyContext from '../../common/MyContext';
import MessageList from './components/MessageList.js';
import MessageDetailList from './components/MessageDetailList.js';
import EmojiPicker from './components/EmojiPicker.js';
import PendingSupportConversations from './components/PendingSupportConversations';
import SupportConversationBot from './components/SupportConversationBot';
import { getSupportRoomId } from './supportBot';

const SUPPORTED_MESSAGE_TYPES = ["text", "image", "video", "voice", "audio"];
const VERIFIED_ROLES = ["IDOL", "COLLABORATOR", "CUSTOMER-SUPPORTER", "ICOIN-MANAGER", "SINGER"];

// Mỗi trang CSKH dùng một nick Official và unmount khi đổi route.
const OFFICIAL_ACCOUNTS = {
  yokara: {
    key: "yokara",
    label: "Yokara",
    language: "en.yokara",
    name: "Yokara Official",
    facebookId: "105912617350916906040",
    profileImageLink: "https://www.ikara.co/avatar/122675726976908",
  },
  ikara: {
    key: "ikara",
    label: "Ikara",
    language: "vi",
    name: "Ikara Official",
    facebookId: "FIREBASE+84826688753",
    profileImageLink: "https://www.ikara.co/avatar/FIREBASE+84826688753",
  },
  yosing: {
    key: "yosing",
    label: "Yosing",
    name: "Yosing Official",
    facebookId: "114267272472947974846",
    profileImageLink: "https://www.ikara.co/avatar/114267272472947974846",
  },
};

const SOUND_ENABLED_STORAGE_KEY = "listChatOfficialSoundEnabled";

function readSoundEnabledPreference() {
  try {
    return localStorage.getItem(SOUND_ENABLED_STORAGE_KEY) !== "false";
  } catch (e) {
    return true;
  }
}

function resolveOfficialAccount(props) {
  const raw = props && props.match && props.match.params && props.match.params.official;
  const key = Object.prototype.hasOwnProperty.call(OFFICIAL_ACCOUNTS, raw) ? raw : "yokara";
  return OFFICIAL_ACCOUNTS[key];
}

function buildUserFromAccount(account) {
  return {
    name: account.name,
    facebookId: account.facebookId,
    profileImageLink: account.profileImageLink,
    url: null,
    totalIcoin: 0,
    uid: null,
    vipOkara: false,
    userId: null,
  };
}

function parseCallableResponse(result) {
    const data = result && result.data;
    if (typeof data !== "string") return data || {};
    try {
        return JSON.parse(data);
    } catch (error) {
        return { status: "FAILED", message: "Phản hồi từ máy chủ không hợp lệ." };
    }
}

function hasVerifiedBadge(user) {
    return !!user && (user.isAdminIkaraYokara === true || VERIFIED_ROLES.includes(user.role));
}

function formatOnlineStatus(status) {
    if (!status) return "Chưa có trạng thái hoạt động";
    if (status.connected === true) return "Đang hoạt động";
    if (!status.lastOnline) return "Đang ngoại tuyến";

    const elapsedMinutes = Math.max(0, Math.floor((Date.now() - status.lastOnline) / 60000));
    if (elapsedMinutes < 1) return "Hoạt động vừa xong";
    if (elapsedMinutes < 60) return `Hoạt động ${elapsedMinutes} phút trước`;
    if (elapsedMinutes < 1440) return `Hoạt động ${Math.floor(elapsedMinutes / 60)} giờ trước`;
    return `Hoạt động ${Math.floor(elapsedMinutes / 1440)} ngày trước`;
}

function getReplyLabel(messageDetail) {
    if (!messageDetail) return "";
    switch (messageDetail.type) {
        case "image": return "Hình ảnh";
        case "video": return "Video";
        case "voice": return "Tin nhắn thoại";
        case "audio": return "File ghi âm";
        default: return messageDetail.message || messageDetail.originalMessage || "Tin nhắn";
    }
}

export default class ListChatSupportUser extends Component {
  constructor(props) {
    super(props);
    this.officialAccount = resolveOfficialAccount(props);
    const user = buildUserFromAccount(this.officialAccount);
    this.state = {
        user: user,
        firebaseUserId: null,
        targetUser: null,
        roomId: "",
        messages: [],
        cursorMessages: null,
        listCache: [],
        listCursorIndex: 0,
        messageDetails: [],
        searchUsers: [],
        cursorMessageDetails: null,
        loaded: false,
        isFirst: false,
        loading: false,
        loadingMessages: false,
        listenFirebaseMessages: null,
        listenFirebaseMessgeDetails: null,
        listenUserOnlineStatus: null,
        message: "",
        messageInputHeight: 46,
        messageInputScrollable: false,
        searchKeyword: "",
        isUserActive: false,
        userOnlineStatus: null,
        replyTo: null,
        actionMessageId: null,
        queryType: "ALL", // ALL, UNREAD, NEED_AGENT
        pendingRefreshVersion: 0,
        showEmojiPicker: false,
        loadingOlder: false,
        soundEnabled: readSoundEnabledPreference(),
        mobileChatOpen: false,
        headerHeight: 60
    }
    // Cờ báo lần snapshot đầu của mỗi phiên nghe: chỉ lần này mới được dựng lại
    // danh sách và cuộn lên đầu. Các snapshot sau (do gửi/nhận tin) chỉ cập nhật
    // ngầm vào listCache để thứ tự item và vị trí cuộn của sidebar giữ nguyên.
    this.isFirstListSnapshot = true;
    this.audioContext = null;
    this.lastNotifyAt = 0;
    // Mỗi nick official cần phiên Firebase riêng: callable gửi tin dùng auth
    // của app, trong khi các trang admin khác cũng đăng nhập Firebase.
    const appName = `support-chat-${this.officialAccount.key}`;
    this.firebaseApp = Firebase.apps.find(app => app.name === appName)
        || Firebase.initializeApp(Firebase.app().options, appName);
    this.ikaraNode = this.firebaseApp.database().ref("ikara");
    this.functions = this.firebaseApp.functions();
    this.auth = this.firebaseApp.auth();
    this.getFirebaseToken = this.getFirebaseToken.bind(this);
    this.accessToken = this.accessToken.bind(this);
    this.unlockAudio = this.unlockAudio.bind(this);
    this.toggleSound = this.toggleSound.bind(this);
    this.playNotificationSound = this.playNotificationSound.bind(this);
    this.notifyIncomingFromList = this.notifyIncomingFromList.bind(this);
    this.listenFirebaseMessages = this.listenFirebaseMessages.bind(this);
    this.listenFirebaseMessgeDetails = this.listenFirebaseMessgeDetails.bind(this);
    this.getMessageDetail = this.getMessageDetail.bind(this);
    this.loadMoreMessageDetails = this.loadMoreMessageDetails.bind(this);
    this.offListen = this.offListen.bind(this);
    this.handleTargetUser = this.handleTargetUser.bind(this);
    this.openConversation = this.openConversation.bind(this);
    this.updateHeaderHeight = this.updateHeaderHeight.bind(this);
    this.sendMessage = this.sendMessage.bind(this);
    this.searchUsers = this.searchUsers.bind(this)
    this.uploadImage = this.uploadImage.bind(this);
    this.acceptSendVideo = this.acceptSendVideo.bind(this);
    this.setQueryType = this.setQueryType.bind(this);
    this.loadMoreList = this.loadMoreList.bind(this);
    this.handleScrollList = this.handleScrollList.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    this.handleSelectEmoji = this.handleSelectEmoji.bind(this);
    this.autoResizeInput = this.autoResizeInput.bind(this);
    this.listenUserOnlineStatus = this.listenUserOnlineStatus.bind(this);
    this.handleReplyMessage = this.handleReplyMessage.bind(this);
    this.handleReaction = this.handleReaction.bind(this);
    this.handleRecallMessage = this.handleRecallMessage.bind(this);
    this.chatContainerRef = createRef();
    this.messagesBoxRef = createRef();
    this.inputRef = createRef();
    this.currentTimeout = null;
    this.chatRequestId = 0;
    this.isChatMounted = false;
  }

  componentDidMount() {
    this.isChatMounted = true;
    this.headerElement = document.getElementById('header');
    this.updateHeaderHeight();
    window.addEventListener('resize', this.updateHeaderHeight);
    if (this.headerElement) {
        this.headerElement.addEventListener('load', this.updateHeaderHeight, true);
        if (window.ResizeObserver) {
            this.headerObserver = new window.ResizeObserver(this.updateHeaderHeight);
            this.headerObserver.observe(this.headerElement);
        }
    }
    // Trang chat cao đúng bằng viewport nên khoá scroll trang ngoài, tránh
    // cuộn hai tầng khi thao tác trong khung tin nhắn.
    document.body.classList.add("chat-page-no-scroll");
    // Browser chặn autoplay: lần click/keydown đầu tiên mới mở AudioContext.
    document.addEventListener("pointerdown", this.unlockAudio, { once: true });
    document.addEventListener("keydown", this.unlockAudio, { once: true });
    this.getFirebaseToken();
  }

  componentWillUnmount() {
    this.isChatMounted = false;
    window.removeEventListener('resize', this.updateHeaderHeight);
    if (this.headerElement) this.headerElement.removeEventListener('load', this.updateHeaderHeight, true);
    if (this.headerObserver) this.headerObserver.disconnect();
    this.chatRequestId += 1;
    document.body.classList.remove("chat-page-no-scroll");
    document.removeEventListener("pointerdown", this.unlockAudio);
    document.removeEventListener("keydown", this.unlockAudio);
    if (this.audioContext) {
        this.audioContext.close().catch(() => {});
        this.audioContext = null;
    }
    // Rời trang thì gỡ listener Firebase, không để chạy nền sau khi unmount.
    this.offListen();
    if (this.currentTimeout) {
        clearTimeout(this.currentTimeout);
    }
  }

  updateHeaderHeight() {
    if (!this.headerElement) return;
    const headerHeight = Math.ceil(this.headerElement.getBoundingClientRect().bottom);
    if (headerHeight > 0 && headerHeight !== this.state.headerHeight) {
        this.setState({ headerHeight });
    }
  }

  unlockAudio() {
    try {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return;
      if (!this.audioContext) {
        this.audioContext = new AudioCtx();
      }
      if (this.audioContext.state === "suspended") {
        this.audioContext.resume();
      }
    } catch (e) {
      // Bỏ qua: môi trường không hỗ trợ Web Audio.
    }
  }

  toggleSound() {
    this.unlockAudio();
    this.setState(prev => {
      const soundEnabled = !prev.soundEnabled;
      try {
        localStorage.setItem(SOUND_ENABLED_STORAGE_KEY, soundEnabled ? "true" : "false");
      } catch (e) {
        // ignore quota / private mode
      }
      return { soundEnabled };
    }, () => {
      if (this.state.soundEnabled) {
        this.playNotificationSound(true);
      }
    });
  }

  // Tiếng ding ngắn kiểu Messenger (Web Audio, không cần file mp3).
  playNotificationSound(force = false) {
    if (!force && !this.state.soundEnabled) return;
    this.unlockAudio();
    const ctx = this.audioContext;
    if (!ctx) return;

    const now = ctx.currentTime;
    const playTone = (freq, startOffset, duration) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, now + startOffset);
      gain.gain.exponentialRampToValueAtTime(0.18, now + startOffset + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + startOffset + duration);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + startOffset);
      osc.stop(now + startOffset + duration + 0.02);
    };
    playTone(880, 0, 0.12);
    playTone(1175, 0.11, 0.14);
  }

  // So list trước/sau snapshot: chỉ kêu khi có tin từ phía user (không phải admin gửi).
  notifyIncomingFromList(prevList, nextList) {
    if (!this.state.soundEnabled) return;
    if (!Array.isArray(nextList) || nextList.length === 0) return;

    const adminId = String(this.state.user && this.state.user.facebookId || "");
    const prevById = new Map((prevList || []).map(item => [item.fromUserId, item]));
    let hasIncoming = false;

    for (let i = 0; i < nextList.length; i++) {
      const item = nextList[i];
      if (String(item.lastUserId || "") === adminId) continue;

      const prev = prevById.get(item.fromUserId);
      if (!prev) {
        hasIncoming = true;
        break;
      }
      if (
        (item.dateTime != null && prev.dateTime != null && item.dateTime > prev.dateTime)
        || (item.lastMessage != null && item.lastMessage !== prev.lastMessage)
      ) {
        hasIncoming = true;
        break;
      }
    }

    if (!hasIncoming) return;

    const now = Date.now();
    if (now - this.lastNotifyAt < 800) return;
    this.lastNotifyAt = now;
    this.playNotificationSound();
  }

  // ALL/UNREAD dùng chung Firebase. NEED_AGENT dùng API chatbot riêng theo app.
  setQueryType(queryType) {
    this.setState({
        queryType: queryType,
        searchKeyword: "",
        searchUsers: []
    }, this.scrollToTop);
  }

  // Cuộn gần lên đầu khung chat thì tải thêm tin nhắn cũ
  handleScroll() {
    const { loaded, loadingOlder, cursorMessageDetails } = this.state;
    const container = this.chatContainerRef.current;
    if (!container || !loaded || loadingOlder) return;
    if (cursorMessageDetails === "END" || cursorMessageDetails == null) return;

    if (container.scrollTop < 150) {
        this.loadMoreMessageDetails();
    }
  }

  getFirebaseToken() {
    const account = this.officialAccount;
    axios.post(global.config.apiDomain + "/rest/admin/getFirebaseToken", account.facebookId, {
        headers : {
            "Content-Type": "application/json"
        }
    })
        .then(res => {
            if (!this.isChatMounted) return;
            if (res.data == null || res.data.user == null) {
                toast.error("Không lấy được token Firebase cho nick official.");
                return;
            }
            const apiUser = res.data.user;
            const mergedUser = {
                ...buildUserFromAccount(account),
                ...apiUser,
                name: apiUser.name || account.name,
                facebookId: account.facebookId,
                profileImageLink: apiUser.profileImageLink || account.profileImageLink,
            };
            this.setState({ user: mergedUser }, () => {
                this.accessToken();
            });
        })
        .catch(error => {
            console.error("getFirebaseToken failed:", error);
            toast.error("Không lấy được token Firebase cho nick official.");
        });
  }

  acceptSendVideo() {
    let acceptSendVideo = false;
    if (this.state.messageDetails && this.state.messageDetails.length > 1) {
        let firstUser = this.state.messageDetails[0].userId;
        this.state.messageDetails.map(value => {
            if (value.userId && value.userId !== firstUser) {
                acceptSendVideo = true;
            }
    })
    }
    return acceptSendVideo;
  }

  accessToken() {
    const { user } = this.state;
    if (!user || !user.firebaseToken) {
        toast.error("Không đăng nhập được nick official, thử lại sau.");
        return;
    }
    this.auth.signInWithCustomToken(user.firebaseToken)
        .then(res => {
            if (!this.isChatMounted) return;
            if (res.user.uid !== this.officialAccount.facebookId) {
                this.auth.signOut();
                toast.error("Token Firebase không khớp nick official của trang.");
                return;
            }
            this.setState({ firebaseUserId: res.user.uid }, () => this.listenFirebaseMessages());
        }).catch(error => {
            console.error("Error signing in with custom token:", error);
            toast.error("Không đăng nhập được nick official, thử lại sau.");
        });
  }

    uploadImage = (event) => {
    var target = event.target;
    if (!target.files || target.files.length === 0) return;
    // Reset input ngay để lần sau chọn lại đúng file này vẫn kích hoạt onChange
    const resetInput = () => { target.value = ""; };

    if(window.confirm("Bạn có chắc muốn gửi file này ?")) {
        if (target.files[0].size > 10495760 ){
            toast.error("Kích thước file phải dưới 10mb.");
            resetInput();
            return;
        }
        this.setState({
            loading: true
        });
        var bucketName = "ikara-data/chat";
        var extension = target.files[0].name.split('.').pop().toLowerCase();
        var keyName = this.guid() + "." + extension;
        var contentType = "image/jpeg";
        if (extension == "png") {
            contentType = "image/png";
        }
        if (extension == "mp4") {
            contentType = "video/mp4";
        }
        if (extension == "mov") {
            contentType = "video/mov";
        }
        if(extension !== "jpeg" && extension !== "jpg" && extension !== "png" && extension !== "mp4" && extension !== "mov") {
            toast.warn("Không đúng định dạng")
            this.setState({
                loading: false
            });
            resetInput();
            return;
        }
        if ((extension === "mp4" || extension === "mov") && !this.acceptSendVideo()) {
            toast.warn("Không thể gửi video do chưa xác lập hội thoại")
            this.setState({
                loading: false
            });
            resetInput();
            return;
        }
        var fileReader = new FileReader();
        fileReader.onload = function () {
            var fd = new FormData();
            fd.append('file', target.files[0]);
            fd.append('bucketName', bucketName);
            fd.append('objectKey', keyName);
            fd.append('contentType', contentType)
            $.ajax({
                url: global.config.apiDomain + '/web.UploadFile',
                data: fd,
                processData: false,
                contentType: false,
                type: 'POST',
                success: function (data) {
                    const fileUrl = '["https://data4.ikara.co/data/minio/' + bucketName + '/' + keyName + '"]';
                    this.setState({ loading: false });
                    resetInput();
                    // Gửi thẳng url vừa upload, KHÔNG đi qua state.message:
                    // state.message dùng chung với ô nhập text nên vừa làm lộ link
                    // trong khung nhập, vừa dễ gửi nhầm ảnh của lần upload trước.
                    if (extension === "mp4" || extension === "mov") {
                        this.sendMessage("video", fileUrl);
                    } else {
                        this.sendMessage("image", fileUrl);
                    }
                }.bind(this),error: function(jqXHR, exception) {
                    console.error("Upload file thất bại:", jqXHR, exception);
                    toast.error("Tải file lên thất bại, vui lòng thử lại.");
                    this.setState({
                        loading: false
                    });
                    resetInput();
                }.bind(this),
            });
        }.bind(this);
        fileReader.readAsArrayBuffer(target.files[0]);
    } else {
        resetInput();
    }
  }

  guid() {
    function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }

    // Firebase push key sinh theo thời gian nên sắp xếp theo key là đúng thứ tự gửi.
    // Tin gửi từ client (localMessage) cũng dùng chính key push() nên nằm đúng chỗ.
    // Tin nào thiếu key thì đẩy về cuối, tránh làm hỏng phần còn lại.
    sortMessageDetails(list) {
        return list.slice().sort((a, b) => {
            const keyA = a.key || a.firebaseId || "";
            const keyB = b.key || b.firebaseId || "";
            if (!keyA) return 1;
            if (!keyB) return -1;
            if (keyA === keyB) return 0;
            return keyA < keyB ? -1 : 1;
        });
    }

    getMessageDetail() {
        const { user, targetUser } = this.state;
        if (!targetUser) return;
        const requestId = ++this.chatRequestId;
        const PAGE_SIZE = 50;
        var roomId = "";
        if (user.facebookId > targetUser.fromUserId) {
            roomId = targetUser.fromUserId + "-" + user.facebookId;
        } else {
            roomId = user.facebookId + "-" + targetUser.fromUserId;
        }
        this.state.roomId = roomId;
        this.ikaraNode
            .child("privateChats")
            .child(roomId)
            .orderByKey()
            .limitToLast(PAGE_SIZE)
            .get()
            .then(snapshot => {
                if (!this.isChatMounted || requestId !== this.chatRequestId) return;
                var messageDetails = [];
                snapshot.forEach(value => {
                    var chatItem = value.val();
                    chatItem.key = value.key;
                    if (chatItem.key != "pushNotification"
                        && chatItem.key != "readLimit"
                        && chatItem.key != "properties") {
                        if(chatItem.type != null && !SUPPORTED_MESSAGE_TYPES.includes(chatItem.type)) {
                            chatItem.originalMessage = "Chưa hỗ trợ xem data";
                        }
                        messageDetails.push(chatItem);
                    }
                })
                // Cursor bám theo KEY vì query dùng orderByKey.
                // Chỉ dừng khi không còn bản ghi nào, việc còn hay hết tin cũ
                // do loadMoreMessageDetails xác định.
                if (messageDetails.length === 0) {
                    this.state.cursorMessageDetails = "END";
                } else {
                    this.state.cursorMessageDetails = messageDetails[0].key;
                }
                // Gộp thay vì ghi đè: listener realtime có thể đã kịp thêm tin mới
                // trong lúc chờ query này trả về, ghi đè sẽ làm mất các tin đó.
                this.setState(prevState => {
                    if (requestId !== this.chatRequestId) return null;
                    const merged = messageDetails.slice();
                    prevState.messageDetails.forEach(item => {
                        const existed = merged.some(
                            o => o.key == item.key
                                || (item.firebaseId && o.key == item.firebaseId)
                                || (o.firebaseId && o.firebaseId == item.key)
                        );
                        if (!existed) merged.push(item);
                    });
                    return {
                        messageDetails: this.sortMessageDetails(merged),
                        loaded: true,
                        loadingOlder: false
                    };
                }, () => {
                    if (!this.isChatMounted || requestId !== this.chatRequestId) return;
                    this.scrollToBottom();
                    // Chỉ lắng nghe sau khi đã có dữ liệu ban đầu, tránh tranh chấp
                    this.listenFirebaseMessgeDetails();
                });
            })
            .catch(() => {
                if (!this.isChatMounted || requestId !== this.chatRequestId) return;
                this.setState({ loaded: true, loadingOlder: false });
                toast.error('Không tải được tin nhắn. Vui lòng tải lại trang.');
            });
    }

    loadMoreMessageDetails() {
        const { roomId, cursorMessageDetails } = this.state;
        const requestId = this.chatRequestId;
        const PAGE_SIZE = 50;

        if (cursorMessageDetails == "END" || cursorMessageDetails == null) return;

        // Ghi lại chiều cao trước khi chèn để giữ nguyên vị trí đang đọc
        const container = this.chatContainerRef.current;
        const prevScrollHeight = container ? container.scrollHeight : 0;
        const prevScrollTop = container ? container.scrollTop : 0;

        this.setState({ loadingOlder: true });

        this.ikaraNode
            .child("privateChats")
            .child(roomId)
            .orderByKey()
            .endAt(cursorMessageDetails)
            .limitToLast(PAGE_SIZE + 1) // +1 vì bản ghi ở cursor đã có sẵn
            .get()
            .then(snapshot => {
                if (!this.isChatMounted || requestId !== this.chatRequestId) return;
                var olderMessages = [];
                snapshot.forEach(value => {
                    var chatItem = value.val();
                    chatItem.key = value.key;
                    if (chatItem.key == "pushNotification"
                        || chatItem.key == "readLimit"
                        || chatItem.key == "properties") {
                        return;
                    }
                    if (chatItem.type != null && !SUPPORTED_MESSAGE_TYPES.includes(chatItem.type)) {
                        chatItem.originalMessage = "Chưa hỗ trợ xem data";
                    }
                    if (!this.state.messageDetails.some(o => o.key == chatItem.key)) {
                        olderMessages.push(chatItem);
                    }
                })

                // Dừng khi cursor không lùi thêm được nữa (đã chạm tin đầu hội thoại),
                // không dựa vào số lượng trả về để kết luận hết tin.
                let nextCursor;
                if (olderMessages.length === 0) {
                    nextCursor = "END";
                } else if (olderMessages[0].key === cursorMessageDetails) {
                    nextCursor = "END";
                } else {
                    nextCursor = olderMessages[0].key;
                }

                this.setState(prevState => ({
                    messageDetails: this.sortMessageDetails(
                        olderMessages.concat(prevState.messageDetails)
                    ),
                    cursorMessageDetails: nextCursor,
                    loadingOlder: false
                }), () => {
                    if (container) {
                        // Bù phần chiều cao mới thêm vào để không bị nhảy khung
                        container.scrollTop = prevScrollTop + (container.scrollHeight - prevScrollHeight);
                    }
                });
            })
            .catch(() => {
                if (!this.isChatMounted || requestId !== this.chatRequestId) return;
                this.setState({ loadingOlder: false });
            });
    }
    
    listenFirebaseMessages() {
        this.offListen();

        const { user } = this.state;
        let { listenFirebaseMessages } = this.state;
        listenFirebaseMessages = this.ikaraNode
            .child("users")
            .child(user.facebookId)
            .child("privateChats");
        
        const PAGE_SIZE = 30;
        const FETCH_SIZE_ALL = 400;
        listenFirebaseMessages = listenFirebaseMessages
            .orderByChild("dateTime")
            .limitToLast(FETCH_SIZE_ALL);

        const recursiveListen = () => {
            listenFirebaseMessages.on('value', snapshot => {
                if (!this.isChatMounted) return;
                let allMessages = [];
                snapshot.forEach(value => {
                    const message = value.val();
                    message.fromUserId = value.key;
                    allMessages.push(message);
                });
                const filteredMessages = allMessages.filter(m => {
                    const msg = typeof m.lastMessage === 'string' ? m.lastMessage : '';
                    return !msg.startsWith('Chào mừng bạn');
                });
                const orderedAll = lodash.orderBy(filteredMessages, "dateTime", 'desc');

                // Snapshot đầu tiên: dựng danh sách từ đầu và cuộn lên trên.
                if (this.isFirstListSnapshot) {
                    this.isFirstListSnapshot = false;
                    const pageData = orderedAll.slice(0, PAGE_SIZE);
                    const hasMore = orderedAll.length > PAGE_SIZE;
                    const cursorMessages = hasMore && orderedAll[PAGE_SIZE - 1]?.dateTime
                        ? orderedAll[PAGE_SIZE - 1].dateTime
                        : "END";
                    this.setState({
                        messages: pageData,
                        cursorMessages,
                        listCache: orderedAll,
                        listCursorIndex: PAGE_SIZE
                    }, () => {
                        this.scrollToTop();
                        this.runForLoop(pageData);
                    });
                    return;
                }

                // Các snapshot sau (gửi/nhận tin): giữ nguyên thứ tự item đang hiển thị
                // và vị trí cuộn. Chỉ cập nhật nội dung từng item tại chỗ (lastMessage,
                // dateTime, isRead...) và nạp ngầm listCache để lần bấm tab sau dùng.
                const prevList = this.state.listCache;
                this.notifyIncomingFromList(prevList, orderedAll);
                this.setState(prev => {
                    const latestById = new Map(orderedAll.map(m => [m.fromUserId, m]));
                    const refreshed = prev.messages.map(
                        item => latestById.get(item.fromUserId) || item
                    );
                    // Hội thoại hoàn toàn mới (chưa từng có trong cache) thì vẫn phải
                    // hiện, nhưng nối vào cuối để không đẩy các item đang đọc dở xuống.
                    // So với listCache chứ không so với messages, vì messages chỉ là
                    // trang đầu - phần chưa load more không phải hội thoại mới.
                    const cachedIds = new Set(prev.listCache.map(item => item.fromUserId));
                    const appended = orderedAll.filter(m => !cachedIds.has(m.fromUserId));
                    return {
                        messages: appended.length > 0 ? [...refreshed, ...appended] : refreshed,
                        listCache: orderedAll
                    };
                }, () => {
                    this.runForLoop(this.state.messages);
                });
            });
        };
        
        this.setState({ listenFirebaseMessages }, () => {
            recursiveListen();
        });

    }

    loadMoreList() {
        const { queryType, cursorMessages, loadingMessages, listCache, listCursorIndex } = this.state;
        const PAGE_SIZE = 30;
        if (loadingMessages) return;
        if (cursorMessages === "END") return;

        const start = listCursorIndex;
        const end = listCursorIndex + PAGE_SIZE;
        const nextSlice = listCache.slice(start, end);

        if (nextSlice.length === 0) {
            this.setState({ cursorMessages: "END" });
            return;
        }

        this.setState(prev => {
            const merged = lodash.orderBy(
                lodash.uniqBy([...prev.messages, ...nextSlice], "fromUserId"),
                "dateTime",
                'desc'
            );
            const newIndex = end;
            const hasMore = newIndex < listCache.length;
            const nextCursor = hasMore && listCache[newIndex - 1]?.dateTime
                ? listCache[newIndex - 1].dateTime
                : "END";
            return {
                messages: merged,
                cursorMessages: nextCursor,
                listCursorIndex: newIndex,
                loadingMessages: false
            };
        });
    }

    handleScrollList(e) {
        const { loadingMessages, cursorMessages, queryType } = this.state;
        // Tab chưa đọc hiển thị trực tiếp toàn bộ item chưa đọc trong listCache.
        if (queryType !== "ALL") return;
        if (loadingMessages) return;
        if (cursorMessages === "END") return;

        const target = e.target;
        const threshold = 120; // px from bottom to trigger load more
        if (target.scrollTop + target.clientHeight >= target.scrollHeight - threshold) {
            this.loadMoreList();
        }
    }

    runForLoop(messages) {
        if(messages && messages.length > 0 && this.state.targetUser == null) {
            this.handleTargetUser(messages[0]);
        }

        // let currentIndex = 0;
        // const executeLoop = () => {
        //     if (this.state.isUserActive) {
        //         this.currentTimeout = setTimeout(executeLoop, 5000);
        //         return;
        //     }
    
        //     if (currentIndex >= 1) {
        //         this.offListen();
        //     }
        //     if (currentIndex >= messages.length) {
        //         console.log("runForLoop")
        //         this.listenFirebaseMessages();
        //         return;
        //     }
        //     this.setState({ targetUser: messages[currentIndex] }, () => {
        //         if (currentIndex >= 5) {
        //             this.scrollToBottom1();
        //         }
        //         if (this.state.targetUser.isRead && !this.state.targetUser.isRead) {
        //             this.changeIsReadConversation(this.state.targetUser);
        //         }
        //         this.getMessageDetail();
        //         currentIndex++;
        //         this.currentTimeout = setTimeout(executeLoop, 20000);
        //     });
        // };
        // if (this.currentTimeout) {
        //     clearTimeout(this.currentTimeout);
        // }
        // executeLoop();
    }

    handleInputChange = (event) => {
        const value = event.target.value;
        const inputSize = this.measureInputSize(event.currentTarget);
        this.setState({
            message: value,
            isUserActive: value.length > 0,
            ...inputSize
        });
    }

    measureInputSize(input) {
        if (!input) return {};
        const styles = window.getComputedStyle(input);
        const lineHeight = parseFloat(styles.lineHeight) || 24;
        const verticalPadding = (parseFloat(styles.paddingTop) || 0) + (parseFloat(styles.paddingBottom) || 0);
        const verticalBorder = (parseFloat(styles.borderTopWidth) || 0) + (parseFloat(styles.borderBottomWidth) || 0);
        const minHeight = parseFloat(styles.minHeight) || Math.ceil(lineHeight + verticalPadding + verticalBorder);
        const maxHeight = parseFloat(styles.maxHeight) || Math.ceil((lineHeight * 5) + verticalPadding + verticalBorder);
        const previousHeight = input.style.height;

        // Thu textarea về một dòng trước khi đo để scrollHeight phản ánh đúng
        // cả trường hợp người dùng vừa xoá bớt nội dung.
        input.style.height = '0px';
        const contentHeight = input.scrollHeight + verticalBorder;
        input.style.height = previousHeight;

        return {
            messageInputHeight: Math.ceil(Math.min(Math.max(contentHeight, minHeight), maxHeight)),
            messageInputScrollable: contentHeight > maxHeight
        };
    }

    // Khung nhập tự giãn theo nội dung, đến đúng 5 dòng mới bắt đầu cuộn.
    autoResizeInput() {
        const inputSize = this.measureInputSize(this.inputRef.current);
        if (Object.keys(inputSize).length > 0) this.setState(inputSize);
    }

    // Enter để gửi, Shift+Enter để xuống hàng
    handleKeyPress = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage("text");
            return;
        }

        const nativeEvent = event.nativeEvent || event;
        const isPlainRepeatedCharacter = event.repeat
            && event.key.length === 1
            && !event.ctrlKey
            && !event.metaKey
            && !event.altKey
            && !nativeEvent.isComposing;

        if (isPlainRepeatedCharacter) {
            event.preventDefault();
            const input = event.currentTarget;
            const start = typeof input.selectionStart === 'number' ? input.selectionStart : input.value.length;
            const end = typeof input.selectionEnd === 'number' ? input.selectionEnd : start;
            const nextMessage = input.value.slice(0, start) + event.key + input.value.slice(end);
            const nextCaret = start + event.key.length;

            this.setState({
                message: nextMessage,
                isUserActive: nextMessage.length > 0
            }, () => {
                this.autoResizeInput();
                if (this.inputRef.current) {
                    this.inputRef.current.setSelectionRange(nextCaret, nextCaret);
                }
            });
        }
    }

    handleSelectEmoji(emoji) {
        const input = this.inputRef.current;
        const { message } = this.state;

        // Chèn emoji đúng vị trí con trỏ đang đứng
        let start = message.length;
        let end = message.length;
        if (input && typeof input.selectionStart === 'number') {
            start = input.selectionStart;
            end = input.selectionEnd;
        }
        const newMessage = message.slice(0, start) + emoji + message.slice(end);

        this.setState({
            message: newMessage,
            isUserActive: newMessage.length > 0
        }, () => {
            this.autoResizeInput();
            if (input) {
                input.focus();
                const caret = start + emoji.length;
                input.setSelectionRange(caret, caret);
            }
        });
    }

    listenUserOnlineStatus(userId) {
        const { listenUserOnlineStatus } = this.state;
        if (listenUserOnlineStatus) listenUserOnlineStatus.off();

        if (!userId) {
            this.setState({ listenUserOnlineStatus: null, userOnlineStatus: null });
            return;
        }

        const onlineRef = this.ikaraNode.child("userOnline").child(userId);
        onlineRef.on('value', snapshot => {
            if (!this.isChatMounted || !this.state.targetUser || this.state.targetUser.fromUserId !== userId) return;
            this.setState({ userOnlineStatus: snapshot.val() || null });
        });
        this.setState({ listenUserOnlineStatus: onlineRef });

        const userRef = this.ikaraNode.child("users").child(userId);
        Promise.all([
            userRef.child("role").once('value'),
            userRef.child("isAdminIkaraYokara").once('value')
        ]).then(([roleSnapshot, adminSnapshot]) => {
            if (!this.isChatMounted || !this.state.targetUser || this.state.targetUser.fromUserId !== userId) return;
            const accountFlags = {
                role: roleSnapshot.val(),
                isAdminIkaraYokara: adminSnapshot.val() === true
            };
            this.setState(prevState => ({
                targetUser: { ...prevState.targetUser, ...accountFlags },
                messages: prevState.messages.map(item => (
                    item.fromUserId === userId ? { ...item, ...accountFlags } : item
                ))
            }));
        }).catch(error => console.error("Không đọc được vai trò tài khoản:", error));
    }
    
    offListen() {
        const { listenFirebaseMessages, listenFirebaseMessgeDetails, listenUserOnlineStatus } = this.state;
        // Điều kiện cũ kiểm tra nhầm sang listenFirebaseMessgeDetails khiến listener
        // danh sách không được gỡ ở lần đổi hội thoại đầu tiên -> chồng listener.
        if(listenFirebaseMessages != null && listenFirebaseMessages != undefined) {
            listenFirebaseMessages.off();
        }

        if(listenFirebaseMessgeDetails != null && listenFirebaseMessgeDetails != undefined) {
            listenFirebaseMessgeDetails.off();
        }

        if(listenUserOnlineStatus != null && listenUserOnlineStatus != undefined) {
            listenUserOnlineStatus.off();
        }
    }

  listenFirebaseMessgeDetails() {
    const { user, targetUser } = this.state;
    let { listenFirebaseMessgeDetails } = this.state;
    var roomId = "";
    if (user.facebookId > targetUser.fromUserId) {
        roomId = targetUser.fromUserId + "-" + user.facebookId;
    } else {
        roomId = user.facebookId + "-" + targetUser.fromUserId;
    }
    this.state.roomId = roomId;
    // limitToLast(1) chỉ theo dõi đúng 1 tin cuối: khi 2 tin về gần nhau, cửa sổ
    // trượt qua làm tin ở giữa không bao giờ bắn child_added -> mất tin, cập nhật sai.
    // Nới cửa sổ để không bỏ sót, phần trùng đã có dedup bên dưới lọc.
    listenFirebaseMessgeDetails = this.ikaraNode
        .child("privateChats")
        .child(roomId)
        .orderByKey()
        .limitToLast(20);
    const requestId = this.chatRequestId;
    listenFirebaseMessgeDetails.on('child_added', snapshot => {
        if (!this.isChatMounted || requestId !== this.chatRequestId) return;
        var chatItem = snapshot.val();
        chatItem.key = snapshot.key;
        if (chatItem.key == "pushNotification"
            || chatItem.key == "readLimit"
            || chatItem.key == "properties") {
            return;
        }
        if (chatItem.type != null && !SUPPORTED_MESSAGE_TYPES.includes(chatItem.type)) {
            chatItem.originalMessage = "Chưa hỗ trợ xem data";
        }
        if (chatItem.key == undefined) return;

        // Dedup phải làm bên trong updater: nhiều tin có thể về liên tiếp trong cùng
        // một nhịp render, đọc this.state ở ngoài sẽ là bản cũ và gây trùng tin.
        this.setState(prevState => {
            const isDuplicated = prevState.messageDetails.some(
                o => o.key == chatItem.key
                    || (o.firebaseId && o.firebaseId == chatItem.key)
                    || (chatItem.firebaseId && o.key == chatItem.firebaseId)
            );
            if (isDuplicated) return null; // không đổi state
            // Sắp xếp lại thay vì append: child_added cũng bắn cho tin cũ vừa lọt vào
            // cửa sổ limitToLast, append thẳng sẽ đẩy tin cũ xuống cuối khung chat.
            return {
                messageDetails: this.sortMessageDetails([
                    ...prevState.messageDetails,
                    chatItem
                ])
            };
        }, () => {
            this.scrollToBottom();
        });

    });

    // Reaction và thu hồi chỉ thay đổi dữ liệu của tin hiện có nên phải nghe
    // child_changed; chỉ nghe child_added sẽ khiến giao diện không cập nhật realtime.
    listenFirebaseMessgeDetails.on('child_changed', snapshot => {
        if (!this.isChatMounted || requestId !== this.chatRequestId) return;
        const changedItem = snapshot.val();
        if (!changedItem || ["pushNotification", "readLimit", "properties"].includes(snapshot.key)) return;
        changedItem.key = snapshot.key;

        this.setState(prevState => ({
            messageDetails: prevState.messageDetails.map(item => {
                const itemId = item.key || item.firebaseId;
                return itemId === snapshot.key ? changedItem : item;
            })
        }));
    });
    this.state.listenFirebaseMessgeDetails = listenFirebaseMessgeDetails;
  }

  handleTargetUser(targetUser) {
    if (!targetUser) return;
    if (this.state.firebaseUserId !== this.officialAccount.facebookId) {
        toast.error('Phiên nick official chưa sẵn sàng. Vui lòng chờ kết nối.');
        return;
    }
    const oldTargetUser = this.state.targetUser;
    if(oldTargetUser != null && targetUser.fromUserId == oldTargetUser.fromUserId) {
        return;
    }
    this.chatRequestId += 1;
    // Luôn gỡ listener chi tiết của hội thoại cũ trước khi chuyển sang hội thoại mới
    const { listenFirebaseMessgeDetails } = this.state;
    if (listenFirebaseMessgeDetails != null) {
        listenFirebaseMessgeDetails.off();
    }
    // Reset dữ liệu hội thoại cũ để phân trang tin nhắn bắt đầu lại từ đầu
    this.setState(prev => ({
        targetUser,
        roomId: getSupportRoomId(this.officialAccount.facebookId, targetUser.fromUserId),
        messages: prev.messages.some(item => item.fromUserId == targetUser.fromUserId)
            ? prev.messages : [targetUser, ...prev.messages],
        searchKeyword: '',
        searchUsers: [],
        messageDetails: [],
        cursorMessageDetails: null,
        loadingOlder: false,
        showEmojiPicker: false,
        replyTo: null,
        userOnlineStatus: null,
        listenFirebaseMessgeDetails: null,
    }), () => {
        this.listenUserOnlineStatus(targetUser.fromUserId);
        this.getMessageDetail();
    });
  }

  openConversation(targetUser) {
    if (!targetUser || this.state.firebaseUserId !== this.officialAccount.facebookId) {
        this.handleTargetUser(targetUser);
        return;
    }
    this.setState({ mobileChatOpen: true }, this.scrollToBottom);
    this.handleTargetUser(targetUser);
  }

  handleSupportResolved = () => {
    this.setState(prev => ({ pendingRefreshVersion: prev.pendingRefreshVersion + 1 }));
  };

  changeIsReadConversation(targetUser) {
    if(this.state.queryType === "UNREAD") return;
    const json = {
        toFacebookId: targetUser.fromUserId
    }
    const jsonBase64 = Base64.encode(JSON.stringify(json));
    const parameters = {
        "parameters": jsonBase64
    }
    const request = this.functions.httpsCallable("v5-ChangeIsReadConversation");
    request(parameters)
        .then(result => {
        }).catch(error => {
            alert(error);
        });
  }

  handleReplyMessage(messageDetail) {
    if (!messageDetail || messageDetail.status === "RECALL") return;
    this.setState({ replyTo: messageDetail, showEmojiPicker: false }, () => {
        if (this.inputRef.current) this.inputRef.current.focus();
    });
  }

  handleReaction(messageDetail, reaction) {
    const messageId = messageDetail && (messageDetail.key || messageDetail.firebaseId);
    if (!messageId || !this.state.roomId || this.state.actionMessageId === messageId) return;

    const parameters = {
        parameters: Base64.encode(JSON.stringify({
            privateChatId: this.state.roomId,
            messageId,
            reaction
        }))
    };

    this.setState({ actionMessageId: messageId });
    this.functions.httpsCallable("v10-SendMessageReaction")(parameters)
        .then(result => {
            const response = parseCallableResponse(result);
            if (response.status === "FAILED") {
                toast.error(response.message || "Không thể thả cảm xúc.");
                return;
            }

            const currentUserId = this.state.firebaseUserId || this.state.user.facebookId;
            this.setState(prevState => ({
                messageDetails: prevState.messageDetails.map(item => {
                    if ((item.key || item.firebaseId) !== messageId) return item;
                    const oldReactions = item.reactions || {};
                    const users = { ...(oldReactions.users || {}) };
                    const details = {};
                    Object.keys(oldReactions.details || {}).forEach(type => {
                        details[type] = { ...oldReactions.details[type] };
                    });

                    const oldReaction = users[currentUserId];
                    if (oldReaction && details[oldReaction]) delete details[oldReaction][currentUserId];
                    delete users[currentUserId];
                    if (oldReaction !== reaction) {
                        users[currentUserId] = reaction;
                        details[reaction] = { ...(details[reaction] || {}), [currentUserId]: "ok" };
                    }
                    return { ...item, reactions: { users, details } };
                })
            }));
        })
        .catch(error => {
            console.error("Thả cảm xúc thất bại:", error);
            toast.error("Không thể thả cảm xúc.");
        })
        .finally(() => this.setState({ actionMessageId: null }));
  }

  handleRecallMessage(messageDetail) {
    const messageId = messageDetail && (messageDetail.key || messageDetail.firebaseId);
    if (!messageId || !this.state.roomId || this.state.actionMessageId === messageId) return;
    if (!window.confirm("Bạn có chắc muốn thu hồi tin nhắn này?")) return;

    const parameters = {
        parameters: Base64.encode(JSON.stringify({
            privateChatId: this.state.roomId,
            messageId
        }))
    };

    this.setState({ actionMessageId: messageId });
    this.functions.httpsCallable("v12-RecallMessage")(parameters)
        .then(result => {
            const response = parseCallableResponse(result);
            if (response.status === "FAILED") {
                toast.error(response.message || "Không thể thu hồi tin nhắn.");
                return;
            }
            if (this.state.replyTo && (this.state.replyTo.key || this.state.replyTo.firebaseId) === messageId) {
                this.setState({ replyTo: null });
            }
            this.setState(prevState => ({
                messageDetails: prevState.messageDetails.map(item => (
                    (item.key || item.firebaseId) === messageId
                        ? {
                            ...item,
                            oldMessage: item.oldMessage || item.originalMessage || item.message,
                            oldType: item.type,
                            status: "RECALL",
                            type: "text",
                            message: "[recalled_message]",
                            originalMessage: "[recalled_message]",
                            reactions: null
                        }
                        : item
                ))
            }));
            toast.success("Đã thu hồi tin nhắn.");
        })
        .catch(error => {
            console.error("Thu hồi tin nhắn thất bại:", error);
            toast.error("Không thể thu hồi tin nhắn.");
        })
        .finally(() => this.setState({ actionMessageId: null }));
  }

  // contentOverride là chuỗi JSON URL dùng khi gửi ảnh/video vừa upload.
  sendMessage = (type, contentOverride) => {
    const { user, targetUser, replyTo } = this.state;
    const message = contentOverride != null ? contentOverride : this.state.message;
    if (message == null || message.trim() === "" || user == null || targetUser == null) {
        return;
    }
    if (this.auth.currentUser?.uid !== this.officialAccount.facebookId
        || this.state.firebaseUserId !== this.officialAccount.facebookId) {
        toast.error("Phiên đăng nhập nick official chưa sẵn sàng. Vui lòng tải lại trang.");
        return;
    }
    const isMediaMessage = contentOverride != null;

    const privateChatId = this.state.roomId;
    const firebaseId = this.ikaraNode.child("privateChats").child(privateChatId).push().key;
    const json = {
        toUserId: targetUser.fromUserId,
        message,
        type,
        friendStatus: targetUser.friendStatus,
        firebaseId,
        parentId: type === "text" && replyTo ? (replyTo.key || replyTo.firebaseId) : null
    };

    if (isMediaMessage) {
        let urls = [];
        try {
            const parsed = JSON.parse(contentOverride);
            urls = Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            console.error("Không parse được URL media vừa upload:", error);
        }
        json.media = urls.map((url, index) => ({
            id: String(index),
            index,
            type,
            url,
            ...(type === "image" ? { thumbnailUrl: url } : {})
        }));
    }

    // Trang admin trước đây gửi ảnh/video qua v10. Giữ luồng này để CSKH có thể
    // gửi media trong hội thoại người lạ; v13 chặn media ở trường hợp đó.
    const callableName = isMediaMessage ? "v10-SendMessage" : "v13-SendMessage";
    const requestData = isMediaMessage ? {
        fromUser: {
            facebookId: user.facebookId,
            name: user.name,
            profileImageLink: user.profileImageLink
        },
        toUser: {
            facebookId: targetUser.fromUserId,
            name: targetUser.userName,
            profileImageLink: targetUser.userProfile
        },
        message,
        type,
        firebaseId
    } : json;

    const jsonBase64 = Base64.encode(JSON.stringify(requestData))
    var parameters = {
        "parameters": jsonBase64
    }
    // Bản ghi hiển thị ngay tại client, đủ field để render giống dữ liệu Firebase trả về
    const localMessage = {
        key: firebaseId,
        firebaseId,
        userId: this.state.firebaseUserId || user.facebookId,
        userName: user.name,
        userProfile: user.profileImageLink,
        message: message,
        type: type,
        dateTime: new Date().getTime(),
        status: "SENT",
        media: json.media,
        parentId: json.parentId,
        parent: replyTo ? {
            id: json.parentId,
            message: replyTo.message || replyTo.originalMessage,
            type: replyTo.type,
            userId: replyTo.userId
        } : null
    }

    this.setState({ loading: true });
    const addMessage = this.functions.httpsCallable(callableName);
    addMessage(parameters).then(result => {
    const response = parseCallableResponse(result);
    if (response.status === "FAILED") {
        toast.error(response.message || "Gửi tin nhắn thất bại.");
        return;
    }
    if (!this.isChatMounted) return;
    this.setState(prevState => {
        const markConversationRead = item => item && item.fromUserId == targetUser.fromUserId
            ? { ...item, isRead: true, lastUserId: user.facebookId }
            : item;
        const isCurrentRoom = prevState.roomId === privateChatId;
        const next = {
            loading: false,
            showEmojiPicker: false,
            targetUser: markConversationRead(prevState.targetUser),
            messages: prevState.messages.map(markConversationRead),
            listCache: prevState.listCache.map(markConversationRead),
            searchUsers: prevState.searchUsers.map(markConversationRead),
            messageDetails: !isCurrentRoom || prevState.messageDetails.some(o => o.key == localMessage.key)
                ? prevState.messageDetails
                : this.sortMessageDetails([...prevState.messageDetails, localMessage])
        };
        // Gửi ảnh/video thì giữ nguyên nội dung đang gõ dở trong ô nhập
        if (!isMediaMessage && isCurrentRoom) {
            next.message = "";
            next.isUserActive = false;
            next.replyTo = null;
        }
        return next;
    }, () => {
        this.autoResizeInput();
        this.scrollToBottom();
    });
    }).catch(error => {
        console.error("Gửi tin nhắn thất bại:", error);
        toast.error("Gửi tin nhắn thất bại.");
    }).finally(() => {
        if (this.isChatMounted) this.setState({ loading: false });
    });
}

  searchUsers() {
    const {searchKeyword} = this.state;
    let {user} = this.state;
    let {targetUser} = this.state;
    if(searchKeyword == "") {
        return;
    }
    axios.post(global.config.apiDomain + "/rest/searchUser", searchKeyword, {
        headers: {
            "Content-Type": "application/json"
        }
    }).then(res => {
        let messages = [];
        if(res.data != null) {
            for(let i = 0; i< res.data.length; i++) {
                if(user.facebookId === res.data[i].facebookId) continue;
                let message = {
                    fromUserId: res.data[i].facebookId,
                    userProfile : res.data[i].profileImageLink,
                    userName : res.data[i].name,
                    role: res.data[i].role,
                    isAdminIkaraYokara: res.data[i].isAdminIkaraYokara,
                    friendStatus: res.data[i].friendStatus,
                    lastMessage: "",
                    dateTime: null
                };
                targetUser= message
                messages.push(message)
            }
            this.handleTargetUser(targetUser)
        }
        this.setState({
            searchUsers: messages
        })
    })
  }

  scrollToBottom = () => {
    if (this.chatContainerRef.current) {
      this.chatContainerRef.current.scrollTop = this.chatContainerRef.current.scrollHeight;
    }
  }

  scrollToBottom1 = () => {
    if (this.messagesBoxRef.current) {
      const currentScrollTop = this.messagesBoxRef.current.scrollTop;
      const newScrollTop = currentScrollTop + 200;
      const maxScrollTop = this.messagesBoxRef.current.scrollHeight - this.messagesBoxRef.current.clientHeight;
      this.messagesBoxRef.current.scrollTop = Math.min(newScrollTop, maxScrollTop);
    }
  }
  
  scrollToTop = () => {
    if (this.messagesBoxRef.current) {
      this.messagesBoxRef.current.scrollTop = 0;
    }
  }

  render() {
    const {
        user,
        firebaseUserId,
        targetUser,
        messages,
        messageDetails,
        searchUsers,
        loaded,
        message,
        searchKeyword,
        userOnlineStatus,
        replyTo,
        soundEnabled
    } = this.state;
    const isShowingSearchResults = !loaded || (searchUsers.length > 0 && searchKeyword !== "");
    const visibleMessages = isShowingSearchResults
        ? searchUsers
        : this.state.queryType === "UNREAD"
            ? this.state.listCache.filter(item => item.isRead === false)
            : messages;
    return (
      <div
        className={`list-chat-support-user${this.state.mobileChatOpen ? ' mobile-chat-open' : ''}`}
        style={{ '--support-header-height': `${this.state.headerHeight}px` }}
      >
        <div className="friends-list">
          <div className="support-inbox-title">Hỗ trợ người dùng · {this.officialAccount.label}</div>
          <div className="search-and-tab">
            <div className="search-box">
              <i className="fa fa-search search-icon" />
              <input
                  value={searchKeyword}
                  onChange={(event) => {
                      if (this.state.queryType === 'NEED_AGENT') this.setState({ queryType: 'ALL' });
                      if(event.target.value === "") {
                          this.setState({ searchUsers: [] });
                      }
                      this.setState({ searchKeyword: event.target.value });
                  }}
                  onKeyPress={(event) => {
                      if(event.key === "Enter") {
                          this.searchUsers();
                      }
                  }}
                  type="text"
                  placeholder="Tìm kiếm..."
                  aria-describedby="button-addon2"
              />
            </div>
            <div className='tab-switch compact'>
              <button
                onClick={() => this.setQueryType("ALL")}
                className={`tab-btn icon ${this.state.queryType === "ALL" ? "active" : ""}`}
                title="Tất cả"
              >
                <i className="fa fa-list-ul" />
              </button>
              <button
                onClick={() => this.setQueryType("UNREAD")}
                className={`tab-btn icon ${this.state.queryType === "UNREAD" ? "active" : ""}`}
                title="Chưa xem"
              >
                <i className="fa fa-envelope-open" />
              </button>
              <button
                type="button"
                className={`tab-btn icon support-pending-filter${this.state.queryType === 'NEED_AGENT' ? ' active' : ''}`}
                title="Cần nhân viên"
                aria-label="Cần nhân viên"
                aria-pressed={this.state.queryType === 'NEED_AGENT'}
                onClick={() => this.setQueryType('NEED_AGENT')}
              >
                <i className="fa fa-headset" aria-hidden="true" />
              </button>
              <button
                type="button"
                className={`sound-toggle-btn ${soundEnabled ? "is-on" : "is-off"}`}
                onClick={this.toggleSound}
                title={soundEnabled ? "Tắt tiếng thông báo tin nhắn" : "Bật tiếng thông báo tin nhắn"}
                aria-pressed={soundEnabled}
                aria-label={soundEnabled ? "Tắt tiếng thông báo" : "Bật tiếng thông báo"}
              >
                <i className={`fa ${soundEnabled ? "fa-volume-up" : "fa-volume-off"}`} aria-hidden="true" />
              </button>
            </div>
          </div>
            <div
              className="messages-box"
              ref={this.messagesBoxRef}
              onScroll={this.handleScrollList}
            >
            {this.state.queryType === 'NEED_AGENT' ? (
                <PendingSupportConversations
                    account={this.officialAccount}
                    user={user}
                    ready={firebaseUserId === this.officialAccount.facebookId}
                    targetUser={targetUser}
                    cachedUsers={this.state.listCache}
                    onSelect={this.openConversation}
                    refreshVersion={this.state.pendingRefreshVersion}
                />
            ) : <MessageList
                messages={visibleMessages}
                user={user}
                targetUser={targetUser}
                handleTargetUser={this.openConversation}
            />}

          </div>

        </div>
        <div className="chat-section">
          <div className="chat-header-wrap">
          <div className="chat-header">
            <button
                type="button"
                className="mobile-chat-back"
                onClick={() => this.setState({ mobileChatOpen: false, showEmojiPicker: false })}
                aria-label="Quay lại danh sách hội thoại"
                title="Quay lại danh sách hội thoại"
            >
                <i className="fa fa-arrow-left" aria-hidden="true" />
            </button>
            {targetUser ? (
                <>
                    <img src={targetUser.userProfile} alt="" className="chat-header-avatar" />
                    <div className="chat-header-info">
                        <div className="chat-header-name">
                            <span>{targetUser.userName}</span>
                            {hasVerifiedBadge(targetUser) && (
                                <span className="verified-badge" title="Tài khoản đã xác minh" aria-label="Tài khoản đã xác minh">
                                    <i className="fa fa-check" aria-hidden="true" />
                                </span>
                            )}
                        </div>
                        <div className={`online-status ${userOnlineStatus && userOnlineStatus.connected ? "is-online" : ""}`}>
                            <span className="online-dot" />
                            {formatOnlineStatus(userOnlineStatus)}
                        </div>
                    </div>
                </>
            ) : 'Đang nói chuyện với...'}
          </div>
          {targetUser && (
              <SupportConversationBot
                  key={`${this.officialAccount.key}:${targetUser.fromUserId}`}
                  account={this.officialAccount}
                  userId={targetUser.fromUserId}
                  onResolved={this.handleSupportResolved}
              />
          )}
          </div>
          {/* Chiều cao do flex chia (xem .chat-container trong CSS), không đặt
              cứng theo vh nữa vì sẽ lệch với khung cha và gây cuộn hai tầng. */}
          <div
            className="chat-container"
            ref={this.chatContainerRef}
            onScroll={this.handleScroll}
          >
            {this.state.loadingOlder && (
                <div className="load-older-indicator">
                    <i className="fa fa-spinner fa-spin" /> Đang tải tin nhắn cũ...
                </div>
            )}
            <div className="mt-2 px-4 chat-box bg-white">
                <MessageDetailList
                    messageDetails={messageDetails}
                    user={user}
                    currentUserId={firebaseUserId || (user && user.facebookId)}
                    targetUser={targetUser}
                    onReply={this.handleReplyMessage}
                    onReact={this.handleReaction}
                    onRecall={this.handleRecallMessage}
                />
            </div>
          </div>
          <div className="chat-composer">
            <div className="input-group-append emoji-wrapper">
              <button
                  type="button"
                  className="emoji-toggle-btn"
                  title="Chèn biểu tượng cảm xúc"
                  onClick={() => this.setState(prev => ({ showEmojiPicker: !prev.showEmojiPicker }))}
              >
                  <span role="img" aria-label="emoji">😊</span>
              </button>
              {this.state.showEmojiPicker && (
                  <EmojiPicker
                      onSelect={this.handleSelectEmoji}
                      onClose={() => this.setState({ showEmojiPicker: false })}
                  />
              )}
            </div>

            <div className="composer-main">
              {replyTo && (
                  <div className="composer-reply-preview">
                      <div>
                          <strong><i className="fa fa-reply" aria-hidden="true" /> Đang phản hồi</strong>
                          <span>{getReplyLabel(replyTo)}</span>
                      </div>
                      <button
                          type="button"
                          className="composer-reply-close"
                          title="Hủy phản hồi"
                          onClick={() => this.setState({ replyTo: null })}
                      >
                          <i className="fa fa-times" aria-hidden="true" />
                      </button>
                  </div>
              )}
              <textarea
                  ref={this.inputRef}
                  onKeyDown={this.handleKeyPress}
                  value={message}
                  onChange={this.handleInputChange}
                  rows={1}
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck={false}
                  placeholder={replyTo ? "Nhập nội dung phản hồi..." : "Nhập tin nhắn (Shift + Enter để xuống dòng)"}
                  aria-describedby="button-addon2"
                  className={`form-control chat-textarea${this.state.messageInputScrollable ? ' is-scrollable' : ''}`}
                  style={{
                      height: this.state.messageInputHeight + 'px',
                      overflowY: this.state.messageInputScrollable ? 'auto' : 'hidden'
                  }}
              />
            </div>

            <div className="input-group-append">
              <button
                  id="button-addon2"
                  className="btn btn-link"
                  onClick={() => this.sendMessage("text")}
                  type="button"
                  disabled={this.state.loading || !targetUser || message.trim() === ""
                      || firebaseUserId !== this.officialAccount.facebookId}
              >
                  {this.state.loading ? <i className="fa fa-spinner fa-spin" /> : <i className="fa fa-paper-plane" />}
              </button>
            </div>

            <div className="input-group-append">
              <label htmlFor="imageAnswer" className="file-input-label">
                  <i className="fa fa-paperclip"></i>
              </label>
              <input
                  type="file"
                  id="imageAnswer"
                  className="custom-file-input"
                  onChange={this.uploadImage}
                  accept="image/jpeg,image/png,video/mp4,video/quicktime"
                  style={{ display: 'none' }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ListChatSupportUser.contextType = MyContext;
